import { Page } from 'components/layout/panel/Page/Page';
import { Paper } from 'components/shared/surfaces/Paper/Paper';
import { useTranslator } from 'components/shared/hooks';
import React from 'react';

export const EmptyView: React.FC = () => {
  const trans = useTranslator();
  return (
    <Page title={trans('EMPTY.BROWSER.TITLE')}>
      <Paper innerSpacing={2} outerSpacing={[0, 2, 2]}>
        {trans('EMPTY.BROWSER.DESCRIPTION')}
      </Paper>
    </Page>
  );
};
